import { IGetIsSchoolDefaultParams } from "./types";

export const getIsSchoolDefault = ({
  defaultSeasons,
  schoolSeasonActive,
}: IGetIsSchoolDefaultParams) => {
  if (defaultSeasons === undefined && schoolSeasonActive === undefined) {
    return true;
  }
  return false;
};



// WEBPACK FOOTER //
// ./src/pages/director/seasons/seasonsPage/utils/getIsSchoolDefault/getIsSchoolDefault.ts